/* eslint-disable @typescript-eslint/default-param-last */
import { GET_COCALLER_APP_SETTINGS } from '../../constants/ActionTypes';
import { ICocallerAppSettings } from '../../types/dhwani/cocallerAppSettings.types';

const initialState: ICocallerAppSettings | null = null;

interface CocallerAppSettingsAction {
  type: string;
  payload: ICocallerAppSettings;
}

/**
 * Cocaller App Settings Reducer
 * @param {ICocallerAppSettings | null} state
 * @param {CocallerAppSettingsAction} action
 * @returns {ICocallerAppSettings | null}
 */
const cocallerAppSettingsReducer = (
  state: ICocallerAppSettings | null = initialState,
  action: CocallerAppSettingsAction
): ICocallerAppSettings | null => {
  switch (action?.type) {
    case `${GET_COCALLER_APP_SETTINGS}_SUCCESS`:
      return action.payload as ICocallerAppSettings;
    default:
      return state;
  }
};

export default cocallerAppSettingsReducer;
